/**
 * @generated SignedSource<<e205ac948210abef790469112d92b257>>
 * @relayHash 020bd2171ccc7a090df26cfa2b134c3e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 216ec97cf1785e4054c59fe5cb51b79108e6f4316ca074a768e4cece5f05f3f5

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type team_teamSearchRefetchQuery$variables = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  id: string;
  organisationId: string;
  searchBy?: string | null | undefined;
  sessionId: string;
  siteId: string;
};
export type team_teamSearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragment_fieldOptionsFragmentRef">;
};
export type team_teamSearchRefetchQuery = {
  response: team_teamSearchRefetchQuery$data;
  variables: team_teamSearchRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": 1000,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "organisationId"
  },
  {
    "defaultValue": "",
    "kind": "LocalArgument",
    "name": "searchBy"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "sessionId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "siteId"
  }
],
v1 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v2 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v3 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v4 = {
  "kind": "Variable",
  "name": "organisationId",
  "variableName": "organisationId"
},
v5 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v6 = {
  "kind": "Variable",
  "name": "sessionId",
  "variableName": "sessionId"
},
v7 = {
  "kind": "Variable",
  "name": "siteId",
  "variableName": "siteId"
},
v8 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v9 = [
  (v1/*: any*/),
  (v2/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "team_teamSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/),
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "team_issueFieldTeamEditviewFull_TeamEditViewWithFieldOptionsFragment_fieldOptionsFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "team_teamSearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v3/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v8/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v9/*: any*/),
                "concreteType": "JiraTeamViewConnection",
                "kind": "LinkedField",
                "name": "teams",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraTeamViewEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraTeamView",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "args": [
                              (v7/*: any*/)
                            ],
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "fullTeam",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "alias": "name",
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "alias": "avatarUrl",
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              }
                            ]
                          },
                          (v8/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v9/*: any*/),
                "filters": [
                  "searchBy",
                  "organisationId",
                  "sessionId"
                ],
                "handle": "connection",
                "key": "team_issueFieldTeamEditviewFull_teams",
                "kind": "LinkedHandle",
                "name": "teams"
              }
            ],
            "type": "JiraTeamViewField"
          },
          (v10/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "216ec97cf1785e4054c59fe5cb51b79108e6f4316ca074a768e4cece5f05f3f5",
    "metadata": {},
    "name": "team_teamSearchRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "12fe32f659e658a621a7d1c1f4c544ab";

export default node;
